import { Button, styled } from '@quillbot/design-system';

const InsertIntoDoc = styled(Button)`
  height: 40px;
  float: left;
  margin-right: 1em;
  @media screen and (max-width: 600px) {
    height: 40px;
    margin: 0;
    &&.insertButton-deault {
      padding: 0 6px 0 6px;
      margin: 0px 15px;
    }
  }

  @media screen and (max-width: 320px) {
    &&.insertButton-deault {
      margin: 0px 11px;
    }
  }
`;

export default InsertIntoDoc;
